var map = {
	"./logo-government-1.png": "7729",
	"./logo-government-10.png": "9985",
	"./logo-government-2-1.png": "d8a1",
	"./logo-government-2.png": "da89",
	"./logo-government-3.png": "4d8f",
	"./logo-government-4.png": "a999",
	"./logo-government-5.png": "2972",
	"./logo-government-6.png": "25e6",
	"./logo-government-7.png": "0088",
	"./logo-government-8.png": "96e2",
	"./logo-government-9.png": "1756"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7e61";